import { render, staticRenderFns } from "./empty_page.vue?vue&type=template&id=738a8a1e&"
import script from "./empty_page.vue?vue&type=script&lang=js&"
export * from "./empty_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports